/** Utah's words for roomextras.ts. */
export const ROOMEXTRAS_UT = {
  /** Food trucks use the commissary's service sink instead of a mop sink (R392-102-3(4)(f)(iii)). */
  mopSinkTruck: "Food trucks use the commissary's service sink (R392-102-3(4)(f)(iii)).",
  /** A home kitchen permit (MEHK) needs no mop sink (Utah's home kitchen permit). */
  mopSinkMehk: "A home kitchen permit (MEHK) doesn't need one.",
} as const;
